function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { FileType } from './types';
/**
 * 获取文件类型
 *
 * @export
 * @param {(File | string | Blob)} file 文件
 * @return {*}  {FileType}
 */

export function getFileType(file) {
  if (typeof file === 'string') {
    return FileType.TEXT;
  }

  var mimeType = file.type;

  var _mimeType$split = mimeType.split('/'),
      type = _mimeType$split[0],
      subType = _mimeType$split[1];

  if (type === 'image') {
    return FileType.IMAGE;
  }

  if (type === 'video' || mimeType === 'application/ogg') {
    return FileType.VIDEO;
  }

  if (type === 'audio') {
    return FileType.AUDIO;
  }

  if (subType === 'pdf') {
    return FileType.PDF;
  }

  if (subType === 'msword' || subType === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return FileType.WORD;
  }

  if (subType === 'vnd.ms-powerpoint' || subType === 'vnd.openxmlformats-officedocument.presentationml.presentation') {
    return FileType.PPT;
  }

  if (subType === 'vnd.ms-excel' || subType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return FileType.EXCEL;
  }

  if (subType === 'plain') {
    return FileType.TXT;
  }

  if (file && file.name.indexOf('.pptx') >= 0) {
    return FileType.PPT;
  }

  return FileType.UNKNOWN;
} // 获取音频时长

export var getAudioDuration = function getAudioDuration(file) {
  return new Promise(function (resolve, reject) {
    var url = URL.createObjectURL(file);
    var audioElement = new Audio(url);
    audioElement.addEventListener('loadedmetadata', function () {
      resolve(Math.ceil(audioElement.duration));
    });
    audioElement.addEventListener('error', function () {
      reject(0);
    });
  });
};
export var materialKeyMap = {
  image: 'picture',
  video: 'video',
  audio: 'audio',
  office: 'doc'
};
export var officeLiveroomId = '27653992'; // 查找素材分组

export var findItemByGroup = function findItemByGroup(items, group_type) {
  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    var _item$sub_groups;

    var item = _step.value;

    if (item.group_type == group_type) {
      return item;
    }

    if ((_item$sub_groups = item.sub_groups) != null && _item$sub_groups.length) {
      var found = findItemByGroup(item.sub_groups, group_type);
      if (found) return found;
    }
  }

  return null;
}; // 读取文件宽高

export function getImageFileInfo(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    var onError = function onError(e) {
      console.error("image parse fail: " + e);
      reject({
        size: file.size
      });
    };

    reader.onload = function (e) {
      var img = new Image();

      img.onload = function () {
        // 获取图片宽高
        var width = img.width;
        var height = img.height;
        resolve({
          width: width,
          height: height,
          size: file.size
        });
      };

      img.onerror = onError;
      img.src = e.target.result;
    };

    reader.onerror = onError;
    reader.readAsDataURL(file);
  });
}
export var EnvMap;

(function (EnvMap) {
  EnvMap["pro"] = "https://api-gw.lizhiweike.com";
  EnvMap["dbg"] = "https://api.dev2.weike.fm";
})(EnvMap || (EnvMap = {}));


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/helpers.js
// module id = 217
// module chunks = 4